import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env?.VITE_FIREBASE_API_KEY || 'AIzaSyCraHrU1adr7hbOfZoFwaGjdJUDOODBb1c',
  authDomain: import.meta.env?.VITE_FIREBASE_AUTH_DOMAIN || 'allup-c99b7.firebaseapp.com',
  projectId: import.meta.env?.VITE_FIREBASE_PROJECT_ID || 'allup-c99b7',
  storageBucket: import.meta.env?.VITE_FIREBASE_STORAGE_BUCKET || 'allup-c99b7.appspot.com',
  messagingSenderId: import.meta.env?.VITE_FIREBASE_MESSAGING_SENDER_ID || '88144373454',
  appId: import.meta.env?.VITE_FIREBASE_APP_ID || '1:88144373454:web:webapp_id_placeholder',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
